$(document).on('turbo:load', function () {
	dropdownToggleBarBind('.dropdown_toggle_bar');
});

function dropdownToggleBarBind(target) {
	$(document).off('click', target).on('click', target, function () {
		var selector = $(this).attr('data-selector');
		$('.dropdown_menu[data-selector="' + selector + '"]').slideToggle(100);
		$(this).find('.fa-caret-right, .fa-caret-down').toggleClass('fa-caret-right fa-caret-down');
	});
}

window.dropdownToggleBarBind = dropdownToggleBarBind;